import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import './modal.scss';

function PopupModal(props) {
  const {
    isOpen,
    title,
    children,
    onPrimaryAction,
    onSecondaryAction,
    secondaryActionText,
    primaryActionText,
  } = props;

  return (
    <Modal isOpen={isOpen} toggle={props.onHide}>
      {title && (
        <ModalHeader toggle={props.onHide}>{title}</ModalHeader>
      )}
      <ModalBody>{children}</ModalBody>
      <ModalFooter>
        {onSecondaryAction && (
          <Button onClick={props.onSecondaryAction} color="link">
            {secondaryActionText || "Cancel"}
          </Button>
        )}
        {onPrimaryAction && (
          <Button onClick={props.onPrimaryAction} color="primary">
            {primaryActionText || "Confirm"}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
}

export { PopupModal };
